export { DiscountsSection } from './DiscountsSection';
